import React from 'react';
import { Button } from './ui/button';

const BenefitsSection = () => {
  const benefits = [
    { title: "Economic Impact", description: "Drive U.S. job creation." },
    { title: "Education Access", description: "Access top-tier educational facilities for your children." },
    { title: "Healthcare Benefits", description: "Avail of world-class healthcare." },
    { title: "Permanent Residency", description: "Secure a permanent home for your family in the U.S." },
    { title: "Citizenship Pathway", description: "Create a clear path to U.S. citizenship" },
    { title: "Investment Security", description: "Invest in secure, government-approved projects" }
  ];

  return (
    <section className="py-16 bg-[#1a3a5c]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-white text-3xl md:text-4xl font-bold text-center mb-12 uppercase">
          Benefits of the U.S. Visa
        </h2>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div key={index} className="border-l-4 border-[#c94a4a] pl-4">
              <h3 className="text-[#c94a4a] text-xl font-bold mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-300 text-sm">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button
            onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="border-white text-white hover:bg-white hover:text-[#1a3a5c] px-8 py-3 rounded font-medium"
          >
            Explore Benefits
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
